/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/27/20
 * Time: 2:10 PM
 */
import React, {Component} from 'react';
import './Auth.scss';
import {Modal} from "semantic-ui-react";
import SectionPolygon from "../../SectionPolygon/SectionPolygon";
import {Button} from "reactstrap";
import * as constants from "../../../const/constants";
import {withRouter} from "react-router";
import * as validator from "../../../utils/validator";
import * as commonFunc from "../../../utils/commonFunc";
import * as authService from "../../../services/auth";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import connect from "react-redux/es/connect/connect";
import md5 from "md5";
import Logo from "../../../assets/img/logo/logo.png";
import {lang,language} from '../../../const/language';

class App extends Component {
    state = {
        current: 0,
        mobile: '',
        otp: '',
        password: '',
        rePassword: '',
        expireTime: 30
    };
    setModalHandler = (str) => {
        if (str === "LOGIN") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
            return;
        }
        this.goToHomeHandler();
    };
    goToHomeHandler = async() => {
        await commonFunc.removeCookiesValues();
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
    };
    textOnChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        if (name === "mobile" || name === "otp") if (!validator.onlyDigit.test(value) && value.length !== 0) return;
        this.setState({[name]: value});
    };
    setCurrentState = (id) => {
        this.setState({current: id})
    };
    proceedHandler = () => {
        let {current, mobile, otp, rePassword, password} = this.state;
        !validator.mobileNumValidator(mobile, 1) ? commonFunc.notifyMessage(language[lang].EnterValidMobileNumber) :
            current === 1 && otp.trim() === "" ? commonFunc.notifyMessage(language[lang].OTPCodeCannotBeEmpty) :
                current === 2 && !validator.passwordRegex.test(password) ? commonFunc.notifyMessage(constants.PASSWORD_TEXT) :
                    current === 2 && password !== rePassword ? commonFunc.notifyMessage(language[lang].PasswordDoNotMatch) :
                        this.submitHandler(current);
    };
    resendOtp = () => {
        this.submitHandler(-1);
    };
    submitHandler = async (id) => {
        let {mobile, otp, password} = this.state;

        if (id === 0 || id === -1) {
            this.props.spinnerHandler({isSpin: true, type: language[lang].SendingVerificationCode});
            await authService.getOtpForExistingNumber(mobile)
                .then(response => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(response.message, response.status);
                    if (response.success) {
                        this.setState({current: 1, expireTime: 30});
                    }
                });
        }
        if (id === 1) {
            const obj = {
                "mobile": mobile,
                "otp": otp
            };
            this.props.spinnerHandler({isSpin: true, type: 5});
            await authService.verfifyOtp(obj)
                .then(response => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(response.message, response.status);
                    if (response.success) {
                        this.setState({current: 2});
                    }
                });
        }
        if (id === 2) {
            const obj = {
                "mobile": mobile,
                "otp": otp,
                "password": md5(password)
            };
            this.props.spinnerHandler({isSpin: true, type: 0});
            await authService.passwordReset(obj)
                .then(response => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(response.message, response.status);
                    if (response.success) {
                      this.setModalHandler("LOGIN");
                    }
                });
        }
    };
    countDown = () => {
        let {current, expireTime} = this.state;
        if (current === 1 && expireTime > 0) {
            this.setState({expireTime: (expireTime - 1)})
        }
    };

    componentDidMount() {
        this.timer = setInterval(this.countDown, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {

        let {current, mobile, otp, rePassword, password, expireTime} = this.state;
        return (
            <Modal size={"tiny"} open={true} centered={true}
                   className={"auth-modal"}>
                <Modal.Header>
                    <div className={"logo-wrapper"}>
                        <img
                            className={"logo-img"}
                            alt="..."
                            src={Logo}
                        />
                    </div>
                    <p className={"lecture-intro login-title"}>{language[lang].ForgotPassword}</p>
                    <SectionPolygon/>
                </Modal.Header>

                <Modal.Content>
                    {/*<div>*/}
                    {/*<CommingSoon />*/}
                    {/*<br/>*/}
                    {/*</div>*/}

                    <p className={"p-tag"}>{language[lang].MobileNumber}</p>
                    <input className={"form-control teach-input"} name={"mobile"} type={"telephone"}
                           placeholder={"Enter your mobile number"} onChange={this.textOnChange} value={mobile}
                           disabled={current !== 0}/>

                    {
                        current === 1 && <div>
                            <p className={"success-modal-text"}>{language[lang].WeHaveSentAVerifyCodeToYourMobile}</p>
                            <p className={"p-tag"}>{language[lang].VerificationCode}</p>
                            <input className={"form-control teach-input"} name={"otp"}
                                   placeholder={"Enter verification code"} onChange={this.textOnChange} value={otp}/>
                        </div>
                    }
                    {
                        current === 2 && <div>
                            <p className={"p-tag"}>{language[lang].NewPassword}</p>
                            <input className={"form-control teach-input"} name={"password"} type={"password"}
                                   value={password}
                                   placeholder={"Enter new password"} onChange={this.textOnChange}/>

                            <p className={"p-tag"}>{language[lang].ReEnterNewPassword}</p>
                            <input className={"form-control teach-input"} name={"rePassword"} type={"password"}
                                   value={rePassword}
                                   placeholder={"Re-enter new password"} onChange={this.textOnChange}/>
                        </div>
                    }

                    <div className={"align-center login-btn-wrapper"}>
                        <Button className="com-btn log-btn normal-txt mb-1" color="default" onClick={this.proceedHandler}>
                            {`${current === 0 ? language[lang].GetMobileVerificationCode : current === 1 ? language[lang].Verify : language[lang].ChangePassword}`}
                        </Button>
                        {current === 1 && expireTime === 0 &&
                        <p className={"expire-text"}>{language[lang].DidNotReceiveTheCode} <label className={'resend-text'}
                                                                                     onClick={this.resendOtp}>{language[lang].Resend}</label>
                        </p>}
                        {current === 1 && expireTime !== 0 && <p className={"expire-text"}>00:<label className={"expire-time-lbl"}>{expireTime < 10 ? `0${expireTime}` : expireTime}</label></p>}
                        {/*Pin expires in*/}
                    </div>

                    <div className={"middle-wrapper"}>
                        {current === 1 && <div>
                            <label className={"small-text"} onClick={() => this.setCurrentState(0)}>{language[lang].ChangeMobileNumber}</label>
                            <br/>
                        </div>
                        }

                        <label className={"small-text"} onClick={() => this.setModalHandler("LOGIN")}>{language[lang].BackToLoginPage}</label>
                    </div>
                </Modal.Content>

                <Modal.Actions onClick={() => this.setModalHandler(null)}>
                    <div className={"home-wrapper"}>
                        <i className="fa fa-home" aria-hidden="true"/>
                        <span>{language[lang].GoToTheHome}</span>
                    </div>
                </Modal.Actions>
            </Modal>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(App));
